import { memo, useEffect } from 'react';
import cn from 'classnames';
import { useModal } from 'src/hooks/useModal';
import { useAsyncFn } from 'src/hooks/useAsyncFn';
import UserService from 'src/services/UserService';
import { IconButton } from 'src/components/buttons';
import ModalReport from './ModalReport';
import ModalResult from './ModalResult';
import styles from './style.module.scss';

const ReportButton = ({
    contentId,
    className = '',
}: {
    contentId: number;
    className?: string;
}) => {
    const { Modal, show, hide } = useModal();
    const { Modal: ModalResp, show: showResp, hide: hideResp } = useModal();

    const [state, reportFn] = useAsyncFn(UserService.report);

    useEffect(() => {
        if (state.value || state.error) {
            showResp();
        }
        hide();
    }, [state.value, state.error]);

    return (
        <>
            <IconButton
                onClick={show}
                className={cn(className)}
                icon="comment-exclamation1"
                text="Báo lỗi nội dung"
                title="Báo lỗi"
            />
            <Modal>
                <ModalReport
                    hide={hide}
                    contentId={contentId}
                    reportFn={reportFn}
                />
            </Modal>
            <ModalResp>
                <ModalResult reportState={state} hide={hideResp} />
            </ModalResp>
        </>
    );
};

export default memo(ReportButton);
